import React from 'react';
import Modal from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ModalForm from '../../components/Modal/ModalForm';
import TextInput from '../../components/TextInput';
import ModalButtons from '../../components/Modal/ModalButtons';
import FileDropZone from '../../components/FileDropZone';

const AddIOCModal = ({ data }) => {
	const { addIOCModalStatus, newIOCText, setNewIOCText, newIOCFile, setNewIOCFile, closeModal, handleAddIOC } = data;
	return (
		<Modal show={addIOCModalStatus.status}>
			<ModalHeading heading={`Add ${addIOCModalStatus.type} Input`} subHeading='(Choose any one)' />
			<ModalForm>
				<div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
					<div style={{ width: '100%' }}>
						<TextInput
							icon='lock'
							label={`Single ${addIOCModalStatus.type} Input`}
							placeholder={`Single ${addIOCModalStatus.type} Input`}
							value={newIOCText.value}
							// disabled={newIOCFile.value !== ''}
							onChange={(e) => {
								setNewIOCText({ value: e.target.value, error: '' });
							}}
							errorMessage={newIOCText.error}
						/>
					</div>

					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: '1rem',
							margin: '0.5rem 0'
						}}
					>
						<div style={{ flex: 1, height: '1px', backgroundColor: 'var(--grey)' }} />
						<span style={{ color: 'var(--text-secondary)', fontSize: '1.2rem', fontWeight: 500 }}>OR</span>
						<div style={{ flex: 1, height: '1px', backgroundColor: 'var(--grey)' }} />
					</div>

					<div style={{ width: '100%' }}>
						<label style={{ 
							display: 'block', 
							marginBottom: '0.5rem',
							fontSize: '1.4rem',
							fontWeight: 500
						}}>
							Multiple {addIOCModalStatus.type} Input
						</label>
						<FileDropZone
							onChange={(e) => {
								setNewIOCFile({ value: e.target.files[0], error: '' });
								setNewIOCText({ value: '', error: '' });
							}}
							selectedFile={newIOCFile.value}
							errorMessage={newIOCFile.error}
							disabled={newIOCText.value !== ''}
							label={`Drop ${addIOCModalStatus.type} file here or click to browse`}
							helperText="Upload a file containing multiple entries"
						/>
					</div>
				</div>
				<ModalButtons
					submitButtonLabel={`Add ${addIOCModalStatus.type}`}
					onSubmit={handleAddIOC}
					cancelButtonLabel='Cancel'
					onCancel={closeModal}
				/>
			</ModalForm>
		</Modal>
	);
};

export default AddIOCModal;
